export function getAge(dob: string) {
  const diff = Date.now() - new Date(dob).getTime();
  const ageDt = new Date(diff);

  return Math.abs(ageDt.getUTCFullYear() - 1970);
}
